module.exports = __webpack_public_path__ + "static/img/examinedetailRX.0192e4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/examinedetailRX.png
// module id = bgQY
// module chunks = 5